import { SET_UI_THEME } from '../actions/constants';
import { LocalStorageKeys } from '../services/localStorage';
import { organisationTheme } from '../globals';

const defaultTheme = require('../theming/defaultTheme.json');
const savedTheme = localStorage.getItem(LocalStorageKeys.__UI_THEME__);
const themeToSet = {
  ...defaultTheme,
  currentTheme: savedTheme || organisationTheme.activeThemeId || 'light',
};

const uiThemeReducer = function (state = themeToSet, action: { type: any; data: any; }) {
  switch (action.type) {
    case SET_UI_THEME: {
      return {
        ...state,
        ...action.data,
      };
    }
    default:
      return state;
  }
};

export default uiThemeReducer;
